



































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";

@Component
export default class DownloadPreviewDialog extends Vue {
  @Ref("download-preview-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String, required: true })
  link!: string;

  onSubmit() {
    this.$emit("ok");
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
